import AbstractValidator from './AbstractValidator';

export default class NumberValidator extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        invalidNumber: 'Dieses Feld muss aus Zahlen bestehen.',
        invalidDecimalMin: 'Die Eingabe enthält weniger als %min_decimals% Nachkommastellen.',
        invalidDecimalMax: 'Die Eingabe enthält mehr als %max_decimals% Nachkommastellen.',
        invalidNumberMin: 'Die Eingabe muss größer oder gleich %min_int% sein.',
        invalidNumberMax: 'Die Eingabe muss kleiner oder gleich %max_int% sein.',
    };

    run()
    {
        let value = String(this.value).replace(',', '.');

        if (isNaN(Number(value)))
        {
            this.error = this.getMessage('invalidNumber');
            return;
        }

        let minDecimals = this._options && this._options.min_decimals ? this._options.min_decimals : 0;
        let maxDecimals = this._options && this._options.max_decimals ? this._options.max_decimals : 0;
        let minInteger  = this._options && typeof this._options.min_int !== 'undefined' ? this._options.min_int : null;
        let maxInteger  = this._options && this._options.max_int ? this._options.max_int : 0;

        let numberString = value.split('.');

        if (minDecimals && numberString[1]?.length < minDecimals)
        {
            this.error = this.getMessage('invalidDecimalMin');
            return;
        }

        if (maxDecimals && numberString[1]?.length > maxDecimals)
        {
            this.error = this.getMessage('invalidDecimalMax');
            return;
        }

        if (minInteger !== null && numberString[0] < minInteger)
        {
            this.error = this.getMessage('invalidNumberMin');
            return;
        }

        if (maxInteger && numberString[0] > maxInteger)
        {
            this.error = this.getMessage('invalidNumberMax');
            return;
        }
    }
}